import { InjectionToken } from "@angular/core";
import { WalletState } from "@features/wallet/application/store/wallet.store";
import { StoragePort } from "@platform/storage/domain/ports/storage.port";

export const WALLET_STORE_STORAGE = new InjectionToken<StoragePort<WalletState>>('WALLET_STORE_STORAGE');
